import { createSlice, current } from '@reduxjs/toolkit'
const initialState = {

  isLoading: false,
  eventId: null,
  event_info: {},
  feature: {},
  event_option: {},
  filters: {},
  digital_prop: {},
  watermark: {},
  data_capture: {},
  social: {},
  email: {},
  sms_sharing: {},
  micro_site: {},
  photo_template_frame: {},
  video_template_frame: {},
  boomerang_template_frame: {},
  brust_gifs: {},
  app_experience_branding: {},
  event_gif: {},
  incentive_offer: [],
  form_builder: {}
}

const createEventSlice = createSlice({
  name: "create-event",
  initialState,

  reducers: {

    eventCreateReset: (state) => {
      state.isLoading = false
      state.eventId = null
      state.event_info = {}
      state.feature = {}
      state.event_option = {}
      state.filters = {}
      state.digital_prop = {}
      state.watermark = {}
      state.data_capture = {}
      state.social = {}
      state.email = {}
      state.sms_sharing = {}
      state.micro_site = {}
      state.photo_template_frame = {}
      state.video_template_frame = {}
      state.boomerang_template_frame = {}
      state.brust_gifs = {}
      state.app_experience_branding = {}
      state.event_gif = {}
      state.incentive_offer = []
      state.form_builder = {}
    },

    eventSharingReset: (state) => {
      state.event_option.social_media = false
      state.event_option.email = false
      state.event_option.text_messaging = false
      state.event_option.microsite = false
    },

    eventDraftToContinue: (state, { payload }) => {
      state.eventId = payload.eventId
      state.event_info = payload.event_info
      state.feature = payload.feature
      state.event_option = payload.event_option
      state.filters = payload.filters
      state.digital_prop = payload.digital_prop
      state.social = payload.social
      state.email = payload.email
      state.sms_sharing = payload.sms_sharing
      state.micro_site = payload.micro_site
      state.photo_template_frame = payload.photo_template_frame
      state.video_template_frame = payload.video_template_frame
      state.boomerang_template_frame = payload.boomerang_template_frame
      state.incentive_offer = payload.incentive_offer
      state.brust_gifs = payload.brust_gifs
      state.event_gif = payload.event_gif
      state.incentive_offer = payload.incentive_offer
    },

    eventIdSet: (state, { payload }) => {
      state.eventId = payload
    },

    eventIsLoading: (state, { payload }) => {
      state.isLoading = payload
    },

    eventInfo: (state, { payload }) => {
      state.event_info = payload
    },

    featureEvent: (state, { payload }) => {
      state.feature = payload
    },
    eventOptionItems: (state, { payload }) => {
      state.event_option = payload
    },


    // child start
    eventFilters: (state, { payload }) => {
      state.filters = payload
    },
    digitalProp: (state, { payload }) => {
      state.digital_prop = payload
    },
    customBrandingState: (state, { payload }) => {
      state.watermark = payload
    },
    dataCapture: (state, { payload }) => {
      state.data_capture = payload
    },
    eventSocial: (state, { payload }) => {
      state.social = payload
    },
    eventEmail: (state, { payload }) => {
      state.email = payload
    },
    eventSmsSharing: (state, { payload }) => {
      state.sms_sharing = payload
    },
    eventMicroSite: (state, { payload }) => {
      state.micro_site = payload
    },
    eventPhotoTemplateFrame: (state, { payload }) => {
      state.photo_template_frame = payload.photo_frame
    },
    eventVideoTemplateFrame: (state, { payload }) => {
      state.video_template_frame = payload.photo_frame
    },
    eventBoomerangTemplateFrame: (state, { payload }) => {
      state.boomerang_template_frame = payload.photo_frame
    },
    eventBrustGifs: (state, { payload }) => {
      state.brust_gifs = payload
    },
    eventAppExperienceBranding: (state, { payload }) => {
      state.app_experience_branding = payload
    },
    eventGif: (state, { payload }) => {
      state.event_gif = payload
    },

    eventIncentiveOffers: (state, { payload }) => {
      state.incentive_offer = JSON.parse(payload)
    },
    eventFormBuilderAdd: (state, { payload }) => {
      state.form_builder = payload.data
    },

    // child end
  }
})

export const {
  eventCreateReset,
  eventSharingReset,
  eventIsLoading,
  eventInfo,
  featureEvent,
  eventOptionItems,
  eventFilters,
  digitalProp,
  customBrandingState,
  dataCapture,
  eventSocial,
  eventEmail,
  eventSmsSharing,
  eventMicroSite,
  eventPhotoTemplateFrame,
  eventVideoTemplateFrame,
  eventBoomerangTemplateFrame,
  eventBrustGifs,
  eventAppExperienceBranding,
  eventDraftToContinue,
  eventIdSet,
  eventGif,
  eventIncentiveOffers,
  eventFormBuilderAdd
} = createEventSlice.actions
export default createEventSlice.reducer